import { useState } from 'react';
import SurveyIntro from './Steps/Intro/SurveyIntro';
import SurveyStepOne from './Steps/One/SurveyStepOne';
import { useAuth } from '../../../../store/auth';
import useAuthModals from '../../../Layout/Menu/useAuthModals';

function ServiceWorkers() {
  const { user, authorized } = useAuth();
  const { content, openLoginModal } = useAuthModals();
  const [showSurvey, setShowSurvey] = useState(false);

  const handleClick = () => {
    if (!authorized) {
      openLoginModal();

      return;
    }
    if (user?.country?.id !== 233) {
      console.log('user not allowed to take survey since he not from US');

      return;
    }
    setShowSurvey(true);
  };

  return (
    <>
      {content}
      {user?.country?.id === 233 ? (
        <>
          {!showSurvey && <SurveyIntro onStart={handleClick} />}
          {showSurvey && <SurveyStepOne />}
        </>
      ) : null}
    </>
  );
}

export default ServiceWorkers;
